const validations = (fieldNames = {}, form) => {
  const missingFields = [];

  for (const [key, value] of Object.entries(form)) {
    if (value === "" || value === null) {
      missingFields.push(fieldNames[key]);
    }
  }

  return missingFields;
};

export default validations;
